const EXTERNAL_LINKS = {
  GUIDE_UTILISATION: {
    label: "Guide d'utilisation",
    link: "https://www.laval.ca/wp-content/uploads/2025/11/guide-utilisation-portail-organisme.pdf",
  },
  SERVICES_EN_LIGNE: {
    label: "Services en ligne",
    link: "https://www.laval.ca/aides-subventions/organismes-benevoles/",
  },
  NOUS_JOINDRE: {
    label: "Nous joindre",
    link: "https://www.laval.ca/aides-subventions/organismes-benevoles/services-organismes/repondant-municipal/",
  },
    POLITIQUE_DE_CONFIDENTIALITE: {
    label: "Politique de confidentialité",
    link: "https://www.laval.ca/organisation-municipale/portrait-ville-laval/politique-confidentialite/",
  },
};

export default EXTERNAL_LINKS;
